<template>
    <div>
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn đã cọc:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus2 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn đã mua hàng:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus5 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn đã phát hàng:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus16 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap >
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn nhập kho TQ:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus11 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn nhập kho VN:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus7 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn xuất kho VN:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus9 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex lg3 sm3 pb-0 pt-0>
                    <v-card-title>Tổng đơn hoàn thành:</v-card-title>
                </v-flex>
                <v-flex lg9 sm9 pb-0 pt-0 pl-2>
                    <v-card-title class="pl-0 font-weight-bold subheading">{{item ? item.TotalStatus10 : 0 | currency}}</v-card-title>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
export default {
    data() {
        return {
            viewName: "thong-ke-don-hang"
        };
    },
    computed: {
        ...mapState({
            item: state => state.analytic.realtime_order.data,
            loading: state => state.analytic.loading
        }),
        roleAdmin() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
    },
    methods: {
        filter_data: function () {
            this.$store.dispatch("analytic/getRealtimeOrder");
        }
    },
    mounted() {
        this.filter_data();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>